<app-navbar />
<div class="container-fluid">
  <div class="panel modern-card">
    <div class="panel-header modern-header">
      <h2>
        <i class="fas fa-users me-2"></i>
        Consulta de Consumidores
      </h2>
    </div>
    <div class="panel-body">
      <!-- Formulário de filtros -->
      <div class="filtro-form modern-form">
        <div class="filter-container">
          <div class="form-group">
            <label for="filterType">
              <i class="fas fa-filter me-1"></i> Filtrar por
            </label>
            <select id="filterType" [(ngModel)]="filterType" class="form-control filter-select">
              <option value="nome">Nome</option>
              <option value="cpf">CPF</option>
              <option value="matricula">Matrícula</option>
            </select>
          </div>
          <div class="form-group">
            <label for="searchTerm">
              <i class="fas fa-search me-1"></i> Termo de Pesquisa
            </label>
            <input id="searchTerm" type="text" [(ngModel)]="searchTerm" class="form-control filter-input"
              placeholder="Digite para pesquisar...">
          </div>
          <div class="form-buttons modern-buttons">
            <button class="btn btn-primary me-2" (click)="applyFilters()" title="Buscar">
              <i class="fas fa-search me-1"></i> Buscar
            </button>
            <button class="btn btn-secondary me-2" (click)="clearFilters()" title="Limpar filtros">
              <i class="fas fa-eraser me-1"></i> Limpar
            </button>
          </div>
        </div>
      </div>

      <!-- Loading spinner -->
      <div *ngIf="loading" class="carregando-container modern-loader">
        <div class="modern-spinner"></div>
        <p>Carregando consumidores...</p>
      </div>

      <!-- Error message -->
      <div *ngIf="error" class="erro-container modern-error">
        <i class="fas fa-exclamation-triangle"></i>
        <p>{{ error }}</p>
        <button (click)="loadAllConsumers()" class="btn btn-outline-primary">
          <i class="fas fa-sync-alt"></i> Tentar novamente
        </button>
      </div>

      <!-- No results message -->
      <div *ngIf="!loading && !error && (!consumers || consumers.length === 0)" class="sem-resultados modern-empty">
        <i class="fas fa-info-circle"></i>
        <p>Nenhum consumidor encontrado com os filtros aplicados.</p>
      </div>

      <!-- Table of consumers -->
      <div *ngIf="!loading && !error && consumers && consumers.length > 0"
        class="table-container modern-table-container">
  <div class="table-responsive">
  <table class="table table-striped modern-table">
          <thead>
            <tr>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-id-card"></i>
                  <span>Matrícula</span>
                </span>
              </th>
              <th class="text-center">
                <span class="th-icon-label">
                  <i class="fas fa-user"></i>
                  <span>Nome</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-address-card"></i>
                  <span>CPF</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-money-bill-wave"></i>
                  <span>Débito</span>
                </span>
              </th>
              <th class="text-center">
                <span class="th-icon-label">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>Endereço</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-cogs"></i>
                  <span>Ações</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let consumer of consumers">
              <td><span class="dados-text ">{{ consumer.matricula || '-' }}</span></td>
              <td><strong class="dados-text">{{ consumer.nomeConsumidor || '-' }}</strong></td>
              <td><span class="cpf-text">{{ formatCpf(consumer.cpf) || '-' }}</span></td>
              <td class="text-center">
                <span class="badge-debito" [ngClass]="consumer.possuiDebito ? 'badge-debito-sim' : 'badge-debito-nao'">
                  <i
                    [class]="consumer.possuiDebito ? 'fas fa-exclamation-circle me-1' : 'fas fa-check-circle me-1'"></i>
                  {{ hasDebt(consumer) }}
                </span>
              </td>
              <td>
                <div class="resumo-text" title="{{ formatAddress(consumer) }}">
                  {{ formatAddress(consumer) }}
                </div>
              </td>
              <td class="text-center">
                <button class="btn btn-primary btn-sm btn-action"
                  (click)="irParaEdicao(consumer)"
                  title="Editar consumidor">
                  <i class="fas fa-edit"></i>
                </button>
              </td>
            </tr>
          </tbody>
  </table>
  </div>

        <!-- Paginação -->
        <div class="pagination-container">
          <div class="pagination-info">
            Mostrando {{consumers.length}} de {{totalItens}} registros | Página {{paginaAtual}} de {{totalPaginas}}
          </div>
          <nav aria-label="Navegação de páginas">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginaAtual === 1">
                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(1)" aria-label="Primeira">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginaAtual === 1">
                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(paginaAtual - 1)"
                  aria-label="Anterior">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>

              <ng-container *ngFor="let pagina of getPaginasDisponiveis()">
                <li class="page-item" [class.active]="pagina === paginaAtual">
                  <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(pagina)">
                    {{pagina}}
                  </a>
                </li>
              </ng-container>

              <li class="page-item" [class.disabled]="paginaAtual === totalPaginas || totalPaginas === 0">
                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(paginaAtual + 1)"
                  aria-label="Próxima">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginaAtual === totalPaginas || totalPaginas === 0">
                <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(totalPaginas)"
                  aria-label="Última">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

